// extracted by mini-css-extract-plugin
module.exports = {"scroll-to-top-fab__fab":"ScrollToTopFab_scroll-to-top-fab__fab__0_heV"};